// TrustCall API endpoint constants.
// All hooks use these constants for consistency.

export const TC = {
  // Dashboard
  DASHBOARD_SERVICE_TYPE: "trustcall/dashboard/service-type-summary",
  DASHBOARD_CARRIER_30D: "trustcall/dashboard/carrier-flagged-30days",
  DASHBOARD_SCORE_SUMMARY: "trustcall/dashboard/score-summary",
  DASHBOARD_FLAGGED_SUMMARY: "trustcall/dashboard/flagged-type-summary",
  DASHBOARD_CARRIERS_FLAGGED: "trustcall/dashboard/carriers-flagged",
  DASHBOARD_FTC_COUNT: "trustcall/dashboard/ftc-flagged-count",
  DASHBOARD_CLEAN_COUNT: "trustcall/dashboard/clean-numbers-count",
  DASHBOARD_FLAGS_REMOVED: "trustcall/dashboard/flags-removed-count",
  DASHBOARD_CALL_VOLUME: "trustcall/dashboard/call-volume-summary",

  // Phones
  PHONES: "trustcall/phones",
  PHONES_ARCHIVE: "trustcall/phones/archive",
  PHONES_FILTERS: "trustcall/phones/filters",
  PHONES_UPLOAD: "trustcall/phones/upload",
  PHONES_BULK_DELETE: "trustcall/phones/bulk-delete",
  PHONES_BULK_DELETE_UPLOAD: "trustcall/phones/bulk-delete/upload",
  PHONES_SCAN: "trustcall/phones/scan",
  PHONES_SCAN_UPLOAD: "trustcall/phones/scan/upload",
  PHONES_QUOTA: "trustcall/phones/quota",
  PHONES_SEND_REMEDIATION: "trustcall/phones/send-remediation-message",

  // Carriers
  CARRIERS_RESCAN: "trustcall/carriers/rescan",
  CARRIERS_RESCAN_ALL: "trustcall/carriers/rescan-all",
  CARRIERS_BULK_TNRM_ADD: "trustcall/carriers/bulk-tnrm-add",
  CARRIERS_BULK_TNRM_REMOVE: "trustcall/carriers/bulk-tnrm-remove",

  // Settings
  SETTINGS: "trustcall/settings",
  SETTINGS_MONITOR_INFO: "trustcall/settings/monitor-info",
  SETTINGS_LEGAL_ENTITIES: "trustcall/settings/legal-entities",
  SETTINGS_LEGAL_ENTITIES_INDUSTRIES: "trustcall/settings/legal-entities/industries",
  SETTINGS_EMAIL: "trustcall/settings/email-frequency",
  SETTINGS_SYSADMIN: "trustcall/settings/sysadmin",
  SETTINGS_WEBHOOKS: "trustcall/settings/webhooks",
  SETTINGS_WEBHOOKS_TEST: "trustcall/settings/webhooks/test",
  SETTINGS_WEBHOOKS_ROTATE: "trustcall/settings/webhooks/rotate-secret",
  SETTINGS_WEBHOOKS_DELIVERIES: "trustcall/settings/webhooks/deliveries",
  SETTINGS_WEBHOOKS_RETRY: "trustcall/settings/webhooks/deliveries",
  SETTINGS_ACTIVATE_DEMO: "trustcall/settings/activate-demo",
  SETTINGS_ADD_TRUSTCALL: "trustcall/settings/add-trustcall",
  SETTINGS_UPGRADE_TC3: "trustcall/settings/upgrade-tc3",
  SETTINGS_BILLING_RESET: "trustcall/settings/billing-reset",
  SETTINGS_CREATE_OVERRIDES: "trustcall/settings/create-overrides",
  SETTINGS_PAUSE_REMEDIATION: "trustcall/settings/sysadmin/pause-remediation",
  SETTINGS_RESUME_REMEDIATION: "trustcall/settings/sysadmin/resume-remediation",
  SETTINGS_DISABLE_HIYA: "trustcall/settings/disable-hiya-feedback",
  SETTINGS_LEGAL_COMPANY_NAME: "trustcall/settings/legal-entities/company-name",

  // Export
  EXPORT_ACTIVE: "trustcall/export/active-csv",
  EXPORT_ARCHIVE: "trustcall/export/archive-csv",
  EXPORT_HIYA: "trustcall/export/hiya-reports",
  EXPORT_SCORES_HISTORY: "trustcall/export/scores-history",
  EXPORT_TNS_VOLUME: "trustcall/export/tns-call-volume",
  EXPORT_TNS_COMPLAINT: "trustcall/export/tns-complaint-data",
  EXPORT_INVENTORY: "trustcall/export/inventory",
} as const;

// Helpers for parameterized endpoints
export function phoneEndpoint(phoneNumber: string, suffix: string): string {
  return `trustcall/phones/${encodeURIComponent(phoneNumber)}/${encodeURIComponent(suffix)}`;
}

export function carrierEndpoint(phoneNumber: string, suffix: string): string {
  return `trustcall/carriers/${encodeURIComponent(phoneNumber)}/${encodeURIComponent(suffix)}`;
}

export function exportScreenshots(
  phoneNumber: string,
  dateCall = "",
  browsersTimeZoneStr = ""
): string {
  const params = new URLSearchParams();
  if (dateCall) params.set("dateCall", dateCall);
  if (browsersTimeZoneStr) params.set("browsersTimeZoneStr", browsersTimeZoneStr);
  const qs = params.toString();
  return `trustcall/export/screenshots/${encodeURIComponent(phoneNumber)}${qs ? `?${qs}` : ""}`;
}

export function screenshotRawEndpoint(
  phoneNumber: string,
  screenshotId: number
): string {
  return `trustcall/carriers/${encodeURIComponent(phoneNumber)}/screenshot-raw/${screenshotId}`;
}
